module.exports = __webpack_public_path__ + "img/c-1.0fbb8f2b.png";